import React, { useCallback, useEffect, useRef, useState } from "react";

import { Form, Formik, Field } from "formik";
import { useHistory, useLocation, useParams } from "react-router";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import {
  isBefore,
  parse,
  isValid,
  format,
  startOfDay,
  isEqual,
} from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Text,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Grid,
  GridItem,
  Divider,
  Box,
} from "@chakra-ui/react";

import LoadingSpinner from "../../../../components/LoadingSpinner";
import CustomDropzone from "../../../../components/CustomDropzone";
import FileInformation from "../../../../components/FileInformation";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";

import RegularidadeSAService from "../../../../../main/services/RegularidadeSAService";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import SemRegistros from "../../../../components/SemRegistros";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { criancaFunc, servicos } from "../../../../../helpers/Funcionalidades";
import { scrollToFieldAnexo } from "../../../../utils/scrollToFIeldAnexo";

const EditarRegularidade = () => {
  const { id } = useParams();
  const history = useHistory();
  const { setEditarRegularidadeServ } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const [anexoEditadoNrRegistro, setAnexoEditadoNrRegistro] = useState(false);
  const [anexoEditadoNrInscricao, setAnexoEditadoNrInscricao] = useState(false);
  const [anexoEditadoNrInscricaoCMAS, setAnexoEditadoNrInscricaoCMAS] =
    useState(false);
  const [initialValues, setInitialValues] = useState({
    numeroRegistro: "",
    validadeNrRegistro: "",
    anexoNrRegistro: null,
    dataAnexoNrRegistro: "",
    numeroInscricao: "",
    validadeNrInscricao: "",
    anexoNrInscricao: null,
    dataAnexoNrInscricao: "",
    numeroInscricaoCMAS: "",
    validadeNrInscricaoCMAS: "",
    anexoNrInscricaoCMAS: null,
    dataAnexoNrInscricaoCMAS: "",
    naturezaServico: "",
  });
  const [data, setData] = useState();
  const [dataSA, setDataSA] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const anexoRef = useRef(null);

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idTipoPendencia, ref);
    },
    [idTipoPendencia]
  );

  useEffect(() => {
    if (
      [
        "60",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "80",
        "81",
        "82",
      ].includes(String(idTipoPendencia))
    ) {
      const timeout = setTimeout(() => {
        requestAnimationFrame(() => {
          if (anexoRef.current) {
            scrollToField(anexoRef);
          }
        });
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [idTipoPendencia, scrollToField]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);

    RegularidadeSAService.getRegularidadeSA(id)
      .then((res) => {
        const {
          numeroRegistro,
          validadeNrRegistro,
          numeroInscricao,
          validadeNrInscricao,
          numeroInscricaoCMAS,
          validadeNrInscricaoCMAS,
          anexoNrRegistro,
          anexoNrInscricao,
          anexoNrInscricaoCMAS,
          servicoAcolhimento,
          dataAnexoNrRegistro,
          dataAnexoNrInscricao,
          dataAnexoNrInscricaoCMAS,
        } = res.data;

        if (!anexoNrRegistro) {
          setAnexoEditadoNrRegistro(true);
        }
        if (!anexoNrInscricao) {
          setAnexoEditadoNrInscricao(true);
        }
        if (!anexoNrInscricaoCMAS) {
          setAnexoEditadoNrInscricaoCMAS(true);
        }

        setInitialValues({
          numeroRegistro: numeroRegistro ? numeroRegistro : "",
          validadeNrRegistro: validadeNrRegistro
            ? format(new Date(validadeNrRegistro), "dd/MM/yyyy")
            : "",
          anexoNrRegistro: null,
          dataAnexoNrRegistro: dataAnexoNrRegistro
            ? format(new Date(dataAnexoNrRegistro), "dd/MM/yyyy")
            : "",
          numeroInscricao: numeroInscricao ? numeroInscricao : "",
          validadeNrInscricao: validadeNrInscricao
            ? format(new Date(validadeNrInscricao), "dd/MM/yyyy")
            : "",
          anexoNrInscricao: null,
          dataAnexoNrInscricao: dataAnexoNrInscricao
            ? format(new Date(dataAnexoNrInscricao), "dd/MM/yyyy")
            : "",
          numeroInscricaoCMAS: numeroInscricaoCMAS ? numeroInscricaoCMAS : "",
          validadeNrInscricaoCMAS: validadeNrInscricaoCMAS
            ? format(new Date(validadeNrInscricaoCMAS), "dd/MM/yyyy")
            : "",
          dataAnexoNrInscricaoCMAS: dataAnexoNrInscricaoCMAS
            ? format(new Date(dataAnexoNrInscricaoCMAS), "dd/MM/yyyy")
            : "",
          anexoNrInscricaoCMAS: null,
          naturezaServico: servicoAcolhimento.naturezaServico,
        });
        setData(res.data);
        setDataSA(servicoAcolhimento);
      })
      .catch((err) => {
        Swal.fire({
          title: "Atenção!",
          text: "Registro não encontrado",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push(`/servico-acolhimento/cadastrar-regularidade/${id}`);
        });
      });
  }, [history, id]);

  const schema = Yup.object().shape({
    numeroRegistro: Yup.string().when(["anexoNrRegistro"], {
      is: (anexoNrRegistro) =>
        anexoNrRegistro || (data.anexoNrRegistro && !anexoEditadoNrRegistro),
      then: Yup.string().required("Este campo é obrigatório"),
      otherwise: Yup.string().nullable(),
    }),
    validadeNrRegistro: Yup.string()
      .nullable()
      .test("validadeBeforeToday", "Validade expirada!", (value) => {
        if (
          !Boolean(value) ||
          data.servicoAcolhimento.naturezaServico === "publica"
        ) {
          return true;
        } else {
          const inputDate = parse(value, "dd/MM/yyyy", new Date());
          const currentDate = startOfDay(new Date());

          return (
            !isBefore(inputDate, currentDate) || isEqual(inputDate, currentDate)
          );
        }
      })
      .test("validDate", "Data inválida!", (value) => {
        if (!!value && data.servicoAcolhimento.naturezaServico === "privada") {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      }),
    anexoNrRegistro: Yup.mixed()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    dataAnexoNrRegistro: Yup.string().when("anexoNrNrRegistro", {
      is: (anexoNrRegistro) =>
        anexoNrRegistro || (data.anexoNrRegistro && !anexoEditadoNrRegistro),
      then: Yup.string()
        .nullable()
        .required("Este campo é obrigatório")
        .test("validDate", "Data inválida!", (value) => {
          if (!value) return false;
          if (value.length !== 10) return false;
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        }),
      otherwise: Yup.string()
        .nullable()
        .test("validDate", "Data inválida!", (value) => {
          if (!value) return true;
          if (value.length !== 10) return false;
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        }),
    }),
    numeroInscricao: Yup.string().when(["anexoNrInscricao"], {
      is: (anexoNrInscricao) =>
        anexoNrInscricao || (data.anexoNrInscricao && !anexoEditadoNrInscricao),
      then: Yup.string().required("Este campo é obrigatório"),
      otherwise: Yup.string().nullable(),
    }),

    validadeNrInscricao: Yup.string()
      .nullable()
      .test("validadeBeforeToday", "Validade expirada!", (value) => {
        if (!Boolean(value)) {
          return true;
        } else {
          const inputDate = parse(value, "dd/MM/yyyy", new Date());
          const currentDate = startOfDay(new Date());

          return (
            !isBefore(inputDate, currentDate) || isEqual(inputDate, currentDate)
          );
        }
      })
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      }),
    anexoNrInscricao: Yup.mixed()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    dataAnexoNrInscricao: Yup.string().when("anexoNrInscricao", {
      is: (anexoNrInscricao) =>
        anexoNrInscricao || (data.anexoNrInscricao && !anexoEditadoNrInscricao),
      then: Yup.string()
        .nullable()
        .required("Este campo é obrigatório")
        .test("validDate", "Data inválida!", (value) => {
          if (!value) return false;
          if (value.length !== 10) return false;
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        }),
      otherwise: Yup.string()
        .nullable()
        .test("validDate", "Data inválida!", (value) => {
          if (!value) return true;
          if (value.length !== 10) return false;
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        }),
    }),

    numeroInscricaoCMAS: Yup.string()
      .nullable()
      .when(["anexoNrInscricaoCMAS"], {
        is: (anexoNrInscricaoCMAS) =>
          data.servicoAcolhimento.naturezaServico === "privada" &&
          (anexoNrInscricaoCMAS ||
            (data.anexoNrInscricaoCMAS && !anexoEditadoNrInscricaoCMAS)),
        then: Yup.string().required("Este campo é obrigatório"),
        otherwise: Yup.string().nullable(),
      }),

    validadeNrInscricaoCMAS: Yup.string()
      .nullable()
      .test("validadeBeforeToday", "Validade expirada!", (value) => {
        if (
          !Boolean(value) ||
          data.servicoAcolhimento.naturezaServico === "publica"
        ) {
          return true;
        } else {
          const inputDate = parse(value, "dd/MM/yyyy", new Date());
          const currentDate = startOfDay(new Date());

          return (
            !isBefore(inputDate, currentDate) || isEqual(inputDate, currentDate)
          );
        }
      })
      .test("validDate", "Data inválida!", (value) => {
        if (!!value && data.servicoAcolhimento.naturezaServico === "privada") {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      }),
    anexoNrInscricaoCMAS: Yup.mixed()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    dataAnexoNrInscricaoCMAS: Yup.string().when("anexoNrInscricaoCMAS", {
      is: (anexoNrInscricaoCMAS) =>
        anexoNrInscricaoCMAS ||
        (data.anexoNrInscricaoCMAS && !anexoEditadoNrInscricaoCMAS),
      then: Yup.string()
        .nullable()
        .required("Este campo é obrigatório")
        .test("validDate", "Data inválida!", (value) => {
          if (!value) return false;
          if (value.length !== 10) return false;
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        }),
      otherwise: Yup.string()
        .nullable()
        .test("validDate", "Data inválida!", (value) => {
          if (!value) return true;
          if (value.length !== 10) return false;
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        }),
    }),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        numeroRegistro,
        numeroInscricao,
        numeroInscricaoCMAS,
        validadeNrRegistro,
        validadeNrInscricao,
        validadeNrInscricaoCMAS,
        dataAnexoNrRegistro,
        dataAnexoNrInscricao,
        dataAnexoNrInscricaoCMAS,
        anexoNrInscricaoCMAS,
        anexoNrInscricao,
        ...resto
      } = values;

      const valuesToSend =
        data.servicoAcolhimento.naturezaServico === "publica"
          ? {
              numeroRegistro: numeroRegistro ? numeroRegistro.trim() : "",
              numeroInscricao: numeroInscricao ? numeroInscricao.trim() : "",
              numeroInscricaoCMAS: numeroInscricaoCMAS.trim(),
              validadeNrRegistro: validadeNrRegistro
                ? parse(
                    validadeNrRegistro,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              validadeNrInscricao: validadeNrInscricao
                ? parse(
                    validadeNrInscricao,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              validadeNrInscricaoCMAS: validadeNrInscricaoCMAS
                ? parse(
                    validadeNrInscricaoCMAS,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              dataAnexoNrRegistro: dataAnexoNrRegistro
                ? parse(
                    dataAnexoNrRegistro,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              dataAnexoNrInscricao: dataAnexoNrInscricao
                ? parse(
                    dataAnexoNrInscricao,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              dataAnexoNrInscricaoCMAS: dataAnexoNrInscricaoCMAS
                ? parse(
                    dataAnexoNrInscricaoCMAS,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              anexoNrInscricao: anexoNrInscricao ? anexoNrInscricao : null,
              anexoEditadoNrInscricao,
              ...resto,
            }
          : {
              numeroRegistro: numeroRegistro ? numeroRegistro.trim() : "",
              numeroInscricao: numeroInscricao ? numeroInscricao.trim() : "",
              numeroInscricaoCMAS: numeroInscricaoCMAS
                ? numeroInscricaoCMAS.trim()
                : "",
              validadeNrRegistro: validadeNrRegistro
                ? parse(
                    validadeNrRegistro,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              validadeNrInscricao: validadeNrInscricao
                ? parse(
                    validadeNrInscricao,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              validadeNrInscricaoCMAS: validadeNrInscricaoCMAS
                ? parse(
                    validadeNrInscricaoCMAS,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              dataAnexoNrRegistro: dataAnexoNrRegistro
                ? parse(
                    dataAnexoNrRegistro,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              dataAnexoNrInscricao: dataAnexoNrInscricao
                ? parse(
                    dataAnexoNrInscricao,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              dataAnexoNrInscricaoCMAS: dataAnexoNrInscricaoCMAS
                ? parse(
                    dataAnexoNrInscricaoCMAS,
                    "dd/MM/yyyy",
                    new Date()
                  ).toISOString()
                : "",
              anexoNrInscricaoCMAS: anexoNrInscricaoCMAS
                ? anexoNrInscricaoCMAS
                : null,
              anexoNrInscricao: anexoNrInscricao ? anexoNrInscricao : null,
              anexoEditadoNrRegistro,
              anexoEditadoNrInscricao,
              anexoEditadoNrInscricaoCMAS,
              ...resto,
            };

      ServicoAcolhimentoService.getServicoAcolhimento(id)
        .then((res) => {
          if (dataSA.naturezaServico !== res.data.naturezaServico) {
            Swal.fire({
              title: "Atenção!",
              text: "A natureza do serviço foi alterada, revise as informações para cadastro!",
              icon: "warning",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            }).then(() => {
              actions.setSubmitting(false);
            });
          } else {
            RegularidadeSAService.atualizarRegularidadeSA(id, valuesToSend)
              .then((res) => {
                Swal.fire({
                  title: "Sucesso!",
                  text: "Registro atualizado com sucesso!",
                  icon: "success",
                  confirmButtonText: "Continuar",
                  confirmButtonColor: "#169499",
                }).then(function () {
                  history.push(
                    "/servico-acolhimento/visualizar-regularidade/" + id
                  );
                });
                actions.setSubmitting(false);
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.data) {
                    if (error.response.data.message) {
                      if (error.response.data.field) {
                        if (error.response.data.field === "Regularidade") {
                          Swal.fire({
                            title: "Atenção!",
                            text: error.response.data.message,
                            icon: "warning",
                            confirmButtonText: "Fechar",
                            confirmButtonColor: "#169499",
                          }).then(() => {
                            history.push(
                              "/servico-acolhimento/visualizar-regularidade/" +
                                id
                            );
                          });
                        } else {
                          const errors = JSON.parse(
                            error.response.data.message
                          );
                          for (let key in errors) {
                            actions.setFieldError(key.toString(), errors[key]);
                          }
                        }
                      } else {
                        Swal.fire({
                          title: "Atenção!",
                          text: error.response.data.message,
                          icon: "warning",
                          confirmButtonText: "Fechar",
                          confirmButtonColor: "#169499",
                        }).then(() => {
                          history.push(
                            "/servico-acolhimento/visualizar-regularidade/" + id
                          );
                        });
                      }
                    } else if (error.response.data.apierror) {
                      if (error.response.data.apierror.subErrors) {
                        error.response.data.apierror.subErrors.forEach(
                          (erro) => {
                            actions.setFieldError(erro.field, erro.message);
                          }
                        );
                      }
                    }
                  }
                } else {
                  console.log(error);
                }
                actions.setSubmitting(false);
              });
          }
        })
        .catch((err) => {
          console.log("Erro na consulta do SA no submit", err);
        });
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack.includes(servicos.regularidadeEditar) ||
      (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) &&
        user?.orgaoExterno?.includes(Number(dataSA?.pessoaJuridica?.id)))) ? (
    data !== undefined && dataSA !== undefined ? (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(props) => (
          <Form>
            {setEditarRegularidadeServ(
              hasFormChanged(initialValues, props.values)
            )}
            <Flex
              mt="15px"
              flexDir="column"
              px="13px"
              py="25px"
              borderRadius="16px"
              w="100%"
              bgColor="#FFF"
              border={
                ["60", "61", "62", "63", "64", "65", "80", "81"].includes(
                  idTipoPendencia
                )
                  ? "3px solid #4299E199"
                  : ""
              }
              ref={anexoRef}
            >
              <Text
                color={"#169499"}
                fontWeight="700"
                fontSize="16px"
                lineHeight="21.6px"
                textTransform="uppercase"
              >
                CMDCA
              </Text>
              <Divider orientation="horizontal" mt="10px" />
              {dataSA.naturezaServico === "privada" && (
                <>
                  <Grid
                    templateColumns={{
                      base: "repeat(1, 1fr)",
                      lg: "repeat(4, 1fr)",
                    }}
                    gap="15px"
                  >
                    <GridItem colSpan={2}>
                      <Field name="numeroRegistro">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={
                              form.errors.numeroRegistro &&
                              form.touched.numeroRegistro
                            }
                            id="numeroRegistro"
                            mt="10px"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor="numeroRegistro"
                            >
                              Número de Registro
                              {props.values.anexoNrRegistro ||
                              !anexoEditadoNrRegistro
                                ? "*"
                                : ""}
                            </FormLabel>
                            <Input
                              {...field}
                              h="42px"
                              name="numeroRegistro"
                              id="numeroRegistro"
                              backgroundColor="#F9FAFB"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe o Número de Registro"
                              onChange={(e) => {
                                form.setFieldValue(
                                  "numeroRegistro",
                                  e.target.value
                                );
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.numeroRegistro}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </GridItem>
                    <GridItem colSpan={1}>
                      <CustomDatepickerWField
                        widthInput={"255px"}
                        fieldName="validadeNrRegistro"
                        label="Validade"
                        placeholder="Informe a Validade do Registro"
                        mt="10px !important"
                      />
                    </GridItem>
                    <GridItem colSpan={1} />
                    <GridItem colSpan={1}>
                      {anexoEditadoNrRegistro || !data.anexoNrRegistro ? (
                        <Flex>
                          <CustomDropzone
                            formProps={props}
                            title="Anexar Registro no CMDCA"
                            fieldName="anexoNrRegistro"
                            height="42px"
                            setAnexoNaoEditado={() => {
                              setAnexoEditadoNrRegistro(false);
                            }}
                          />
                        </Flex>
                      ) : (
                        data.anexoNrRegistro && (
                          <FileInformation
                            label="Anexar Registro no CMDCA"
                            name={data.anexoNrRegistro.nomeArquivo}
                            path={data.anexoNrRegistro.pathAnexo
                              .toString()
                              .split("/")
                              .pop()}
                            setAnexoEditado={() => {
                              setAnexoEditadoNrRegistro(true);
                            }}
                            isVisualizacao={false}
                            height="42px"
                          />
                        )
                      )}
                    </GridItem>
                    <GridItem colSpan={1} />
                    <GridItem colSpan={1}>
                      <CustomDatepickerWField
                        widthInput={"255px"}
                        fieldName="dataAnexoNrRegistro"
                        label={`Data do Documento ${
                          props.values.anexoNrRegistro ||
                          !anexoEditadoNrRegistro
                            ? "*"
                            : ""
                        }`}
                        placeholder="Informe a data"
                      />
                    </GridItem>
                  </Grid>
                </>
              )}
              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  lg: "repeat(4, 1fr)",
                }}
                gap="15px"
                mt="20px"
              >
                <GridItem colSpan={2}>
                  <Field name="numeroInscricao">
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={
                          form.errors.numeroInscricao &&
                          form.touched.numeroInscricao
                        }
                        id="numeroInscricao"
                        mt="10px"
                      >
                        <FormLabel
                          color="#5F6377"
                          fontWeight="500"
                          fontSize="14px"
                          lineHeight="19.6px"
                          htmlFor="numeroInscricao"
                        >
                          Número de Inscrição
                          {(data.anexoNrInscricao &&
                            !anexoEditadoNrInscricao) ||
                          props.values.anexoNrInscricao
                            ? "*"
                            : ""}
                        </FormLabel>
                        <Input
                          {...field}
                          h="42px"
                          name="numeroInscricao"
                          id="numeroInscricao"
                          backgroundColor="#F9FAFB"
                          autoComplete="off"
                          border="1px solid #D7D8DE"
                          placeholder="Informe o Número de Inscrição"
                          onChange={(e) => {
                            form.setFieldValue(
                              "numeroInscricao",
                              e.target.value
                            );
                          }}
                        />
                        <FormErrorMessage>
                          {form.errors.numeroInscricao}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </GridItem>
                <GridItem colSpan={1}>
                  <CustomDatepickerWField
                    widthInput={"255px"}
                    fieldName="validadeNrInscricao"
                    label="Validade"
                    placeholder="Informe a Validade da Inscrição"
                    mt="10px !important"
                  />
                </GridItem>
                <GridItem colSpan={1} />
                <GridItem colSpan={1}>
                  {anexoEditadoNrInscricao || !data.anexoNrInscricao ? (
                    <Flex>
                      <CustomDropzone
                        formProps={props}
                        title={`Anexar Inscrição no CMDCA`}
                        fieldName="anexoNrInscricao"
                        height="42px"
                        setAnexoNaoEditado={() => {
                          setAnexoEditadoNrInscricao(false);
                        }}
                      />
                    </Flex>
                  ) : (
                    data.anexoNrInscricao && (
                      <FileInformation
                        label={`Anexar Inscrição no CMDCA`}
                        name={data.anexoNrInscricao.nomeArquivo}
                        path={data.anexoNrInscricao.pathAnexo
                          .toString()
                          .split("/")
                          .pop()}
                        setAnexoEditado={() => {
                          setAnexoEditadoNrInscricao(true);
                        }}
                        isVisualizacao={false}
                        height="42px"
                      />
                    )
                  )}
                </GridItem>
                <GridItem colSpan={1} />
                <GridItem colSpan={1}>
                  <CustomDatepickerWField
                    widthInput={"255px"}
                    fieldName="dataAnexoNrInscricao"
                    label={`Data do Documento${
                      props.values.anexoNrInscricao || !anexoEditadoNrInscricao
                        ? "*"
                        : ""
                    }`}
                    placeholder="Informe a data"
                  />
                </GridItem>
              </Grid>
            </Flex>
            {dataSA.naturezaServico === "privada" && (
              <>
                <Flex
                  mt="15px"
                  flexDir="column"
                  px="13px"
                  pb="25px"
                  borderRadius="16px"
                  w="100%"
                  bgColor="#FFF"
                  border={
                    ["66", "67", "68", "82"].includes(idTipoPendencia)
                      ? "3px solid #4299E199"
                      : ""
                  }
                  ref={anexoRef}
                >
                  <Text
                    color={"#169499"}
                    fontWeight="700"
                    fontSize="16px"
                    lineHeight="21.6px"
                    textTransform="uppercase"
                    mt="20px"
                  >
                    CMAS
                  </Text>
                  <Divider orientation="horizontal" my="10px" />
                  <Grid
                    templateColumns={{
                      base: "repeat(1, 1fr)",
                      lg: "repeat(4, 1fr)",
                    }}
                    gap="15px"
                  >
                    <GridItem colSpan={2}>
                      <Field name="numeroInscricaoCMAS">
                        {({ field, form }) => (
                          <FormControl
                            isInvalid={
                              form.errors.numeroInscricaoCMAS &&
                              form.touched.numeroInscricaoCMAS
                            }
                            id="numeroInscricaoCMAS"
                            mt="10px"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor="numeroInscricaoCMAS"
                            >
                              Número de Inscrição
                              {props.values.anexoNrInscricaoCMAS ||
                              !anexoEditadoNrInscricaoCMAS
                                ? "*"
                                : ""}
                            </FormLabel>
                            <Input
                              {...field}
                              h="42px"
                              name="numeroInscricaoCMAS"
                              id="numeroInscricaoCMAS"
                              backgroundColor="#F9FAFB"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe o Número de Inscrição"
                              onChange={(e) => {
                                form.setFieldValue(
                                  "numeroInscricaoCMAS",
                                  e.target.value
                                );
                              }}
                            />
                            <FormErrorMessage>
                              {form.errors.numeroInscricaoCMAS}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Field>
                    </GridItem>
                    <GridItem colSpan={1}>
                      <CustomDatepickerWField
                        widthInput={"255px"}
                        fieldName="validadeNrInscricaoCMAS"
                        label="Validade"
                        placeholder="Informe a Validade da Inscrição"
                        mt="10px !important"
                      />
                    </GridItem>
                    <GridItem colSpan={1} />
                    <GridItem colSpan={1}>
                      {anexoEditadoNrInscricaoCMAS ||
                      !data.anexoNrInscricaoCMAS ? (
                        <Flex>
                          <CustomDropzone
                            formProps={props}
                            title="Anexar Inscrição no CMAS"
                            fieldName="anexoNrInscricaoCMAS"
                            height="42px"
                            setAnexoNaoEditado={() => {
                              setAnexoEditadoNrInscricaoCMAS(false);
                            }}
                          />
                        </Flex>
                      ) : (
                        data.anexoNrInscricaoCMAS && (
                          <FileInformation
                            label="Anexar Inscrição no CMAS"
                            name={data.anexoNrInscricaoCMAS.nomeArquivo}
                            path={data.anexoNrInscricaoCMAS.pathAnexo
                              .toString()
                              .split("/")
                              .pop()}
                            setAnexoEditado={() => {
                              setAnexoEditadoNrInscricaoCMAS(true);
                            }}
                            isVisualizacao={false}
                            height="42px"
                          />
                        )
                      )}
                    </GridItem>
                    <GridItem colSpan={1} />
                    <GridItem colSpan={1}>
                      <CustomDatepickerWField
                        widthInput={"255px"}
                        fieldName="dataAnexoNrInscricaoCMAS"
                        label={`Data do Documento${
                          props.values.anexoNrInscricaoCMAS ||
                          !anexoEditadoNrInscricaoCMAS
                            ? "*"
                            : ""
                        }`}
                        placeholder="Informe a data"
                      />
                    </GridItem>
                  </Grid>
                </Flex>
              </>
            )}

            <Flex mt="30px" justifyContent="flex-end">
              <Button
                id="button-salvar"
                type="submit"
                translate="no"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                w="17%"
                isLoading={props.isSubmitting}
              >
                Salvar
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    ) : (
      <LoadingSpinner loading={data === undefined} />
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default EditarRegularidade;
